const PLP_SLUG = 'c';

export const PLP_ROUTE = `${PLP_SLUG}`;
export const SLASH_C_ROUTE = `/${PLP_SLUG}/`;
export const SLASH_C_PATH = `/${PLP_SLUG}?`;
export const PROMO_FLAGS = {
  codeBaseCarousel: 'SBC',
  cmsBasedCarousel: 'CMS',
  defaultCarousel: 'DEFAULT',
};
